function ConnectStringandNum(String, num) { //convert a num and a string to a string the num in the end
  let numofstring = num.toString();
  return String + numofstring;
}

function CreateArrayAnswer(CountofAnswer, Data, count , rand) {
  const min = 1;
  const max = 4;


  let ArrayAnswer = [];
  // console.log("rand is :", rand);
  if (Math.round(rand % 2) === 0) {
    // console.log("condition Math.round(rand % 2) === 0)");
    // ArrayAnswer.push(Data.Answer2[count]);
    ArrayAnswer.push(Data.Answer1[count]);
    ArrayAnswer.push(Data.Answer2[count]);
    ArrayAnswer.push(Data.Answer3[count]);
    ArrayAnswer.push(Data.Answer4[count]);
    ArrayAnswer = ArrayAnswer.slice(0, CountofAnswer[count]);
  } else 
  if (Math.round(rand % 3) === 0) {
    // console.log("condition Math.round(rand % 3) === 0)");
    // ArrayAnswer.push(Data.Answer2[count]);
    ArrayAnswer.push(Data.Answer1[count]);
    ArrayAnswer.push(Data.Answer2[count]);
    ArrayAnswer.push(Data.Answer3[count]);
    ArrayAnswer.push(Data.Answer4[count]);
    ArrayAnswer = ArrayAnswer.slice(0, CountofAnswer[count]);
  } else {
    // console.log("default condition");
    ArrayAnswer.push(Data.Answer1[count]);
    ArrayAnswer.push(Data.Answer2[count]);
    ArrayAnswer.push(Data.Answer3[count]);
    ArrayAnswer.push(Data.Answer4[count]);
    ArrayAnswer = ArrayAnswer.slice(0, CountofAnswer[count]);
  }

  return ArrayAnswer;
}

function CreateArrayAnswerCorrect(CountofAnswer, Data, count) {
  let ArrayAnswerCorrect = [];
  ArrayAnswerCorrect.push(Data.AnswerCorrect1[count]);
  ArrayAnswerCorrect.push(Data.AnswerCorrect2[count]);
  ArrayAnswerCorrect.push(Data.AnswerCorrect3[count]);
  ArrayAnswerCorrect.push(Data.AnswerCorrect4[count]);
  ArrayAnswerCorrect.slice(0 , CountofAnswer);
  return ArrayAnswerCorrect;
}

function CountWithFalse(Count, jsonData){
  let ArrayFalseTrue =[];
  for (let i = 0; i < jsonData.NumAnswer[Count]; i++) {
    ArrayFalseTrue.push(false);
  }

   return ArrayFalseTrue;
}

function CountWithFalseEnglish(Count, jsonData){
  let ArrayFalseTrue =[];
  for (let i = 0; i < jsonData.NumAnswer[Count]; i++) {
    ArrayFalseTrue.push(false);
  }

   return ArrayFalseTrue;
}

function CreateFalseArray(ArrayAnswer) {  // create object with 2 boolean(false and 1)
  let ArrayFalse = [];
  let ArrayFalseTrue =[];
  let ArrayZeroOne =[];
  for (let i = 0; i < ArrayAnswer.length; i++) {
    ArrayFalseTrue.push(false);
    ArrayZeroOne.push(0);
  }
  ArrayFalse.ArrayFalseTrue = ArrayFalseTrue;
  ArrayFalse.ArrayZeroOne = ArrayZeroOne;
  return ArrayFalse;
}

function CheckObject(ObjectAnswerFalse , ArrayCorrect){
    for(let i=0 ; i < ObjectAnswerFalse.AllAnswer.length ; i++ ){
        for(let k =0 ; k<ArrayCorrect.length ; k++){
                if(ObjectAnswerFalse.AllAnswer[i] === ArrayCorrect[k]){
                    ObjectAnswerFalse.ArrayZeroOne[i]=1;
                }
            }
    }

}

function CheckTheArray(ArrayTF , ArrayZeroOne){
  // console.log("ArrayTF" ,ArrayTF );
  // console.log("ArrayZeroOne" ,ArrayZeroOne );

  for(let i =0 ; i < ArrayTF.length ; i++){
    if(ArrayTF[i] == ArrayZeroOne[i]){

    }
    else{
      return false;
    }
  }
  return true;
}

// var imgEnlarged = "";

// function imgEnlarge(e){
//   // if (imgEnlarged=="img1"){ 
//   //   e.style.width = "400px";
//   //   // imgEnlarged = 1;
//   //   // otherEnlargedImgs[e] = 1 
//   // }
//   console.log(e);
// }

// function openImageModal(){
//   return (
//     <Modal_image
//       isOpen={"true"}
//       contentLabel='Image Modal'
//       shouldCloseOnOverlayClick={true}
//       portalClassName='modal_image'
//     />
//   );
// }

export {
  CreateFalseArray,
  ConnectStringandNum,
  CreateArrayAnswer,
  CreateArrayAnswerCorrect,
  CheckObject,
  CheckTheArray,
  CountWithFalse,
  CountWithFalseEnglish 
};
